import { render, staticRenderFns } from "./areaprintcollection.vue?vue&type=template&id=d399dfba&"
import script from "./areaprintcollection.vue?vue&type=script&lang=js&"
export * from "./areaprintcollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports